import Headroom from 'headroom.js';

// Headroom fixed header
var header = document.querySelector("#main-header.is-fixed");

if (header) {
    var headroom = new Headroom(header, {
        offset: 50,
        frozen: true,
        tolerance: {
            down: 50,
            up: 0
        }
    });

    headroom.init();
}